export interface ThemeCategory {
  id: string;
  label: string;
  themes: string[];
}

export const themeCategories: ThemeCategory[] = [
  {
    id: 'classics',
    label: 'Classics',
    themes: [
      '60s',
      '70s',
      '80s',
      '90s',
      '2000s',
      '2010s',
      '2020s',
      'Pop',
      'Rock',
      'Rap',
      'Punk',
      'Disney',
      'Sad songs',
      'Love songs',
      'Duet songs',
      'Get the party started',
      'Karaoke classics',
      'One-hit wonders',
      'Guilty pleasures',
      'Christmas songs',
      'Boy bands',
      'Girl groups',
      'Summer hits',
      'Songs everyone knows',
    ],
  },
  {
    id: 'genres',
    label: 'Genres & styles',
    themes: [
      'R&B',
      'Soul',
      'Funk',
      'Disco',
      'Dance & EDM',
      'House',
      'Techno',
      'Drum & bass',
      'Metal',
      'Pop-punk',
      'Emo',
      'Indie',
      'Alternative rock',
      'Country',
      'Folk & acoustic',
      'Jazz',
      'Blues',
      'Reggae',
      'Reggaeton',
      'K-pop',
      'Classical',
      'Musicals',
    ],
  },
  {
    id: 'moods',
    label: 'Moods & energy',
    themes: [
      'Heartbreak anthems',
      'Happy songs',
      'Angry songs',
      'Chill songs',
      'Songs that give you goosebumps',
      'Songs to cry in the shower to',
      'Songs to scream in the car',
      'Songs that make you feel unstoppable',
      'Songs for a rainy day',
      'Songs for a midnight drive',
      'Songs for a lazy Sunday',
      'Songs to fall asleep to',
      'Songs for the gym',
      'Songs for a road trip',
      'Songs that feel like summer',
      'Songs that sound like falling in love',
    ],
  },
  {
    id: 'life-moments',
    label: 'Your life',
    themes: [
      'Your wedding dance song',
      'Your funeral song',
      'Your parents are fighting: a song to tune them out',
      'A song from your childhood',
      'A song your parents always played',
      'A song from your teenage years',
      'A song that reminds you of your first crush',
      'A song that reminds you of a friend',
      'The first song you learned every word to',
      'A song from your first concert',
      'A song you used to have on repeat',
      'A song you discovered this year',
      'A song you know by heart',
      'A song you would dedicate to someone here',
      'A song that helped you through a hard time',
      'Your walk-on song',
      'Your end-of-night song',
      'The soundtrack to your life right now',
    ],
  },
  {
    id: 'creative',
    label: 'What if…',
    themes: [
      'The song playing when you enter as the villain',
      'The song for your training montage',
      'The song for your slow-motion entrance',
      'The song for your escape from a zombie apocalypse',
      'The song playing as you walk away from an explosion',
      'The song for your dramatic breakup in the rain',
      'The song for quitting your job in style',
      'The song you would send to aliens',
      'The song playing at the end of the world',
      'The song you would sing to save your life',
      'The song for a heist that goes terribly wrong',
      'The song for winning the lottery',
      'The song for getting ready with your friends',
      'The song for dancing alone in your kitchen',
      'A song that sounds happy but has sad lyrics',
      'A song with a ridiculous title',
      'A song with a place in the title',
      'A song with a color in the title',
      'A cover better than the original',
      'A song you would defend in court',
    ],
  },
  {
    id: 'screen',
    label: 'Screen & soundtracks',
    themes: [
      'Anime',
      'Movie soundtracks',
      'Video game soundtracks',
      'TV theme songs',
      'Cartoon theme songs',
      'Songs from movie villains',
      'Songs from iconic movie scenes',
      'Songs from racing games',
      'Boss battle music',
      'Anime: rename the song to the anime title',
      'Movies: rename the song to the movie title',
      'Video games: rename the song to the video game title',
    ],
  },
];
